import { render } from "./suporte_login.vue?vue&type=template&id=511a5fa6"
import script from "./suporte_login.vue?vue&type=script&lang=js"
export * from "./suporte_login.vue?vue&type=script&lang=js"

import "./suporte_login.vue?vue&type=style&index=0&id=511a5fa6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__